<template>
  <div>
    <div class="addon-product">
          <input :id="'addon-' + product.id" type="checkbox" class="checkbox" @change="onChange($event)" :checked="product.is_current_addon" :disabled="product.is_current_addon"/>
          <label class="box" :for="'addon-' + product.id"></label>
          <label :for="'addon-' + product.id" class="text">
            <span>
              <strong>{{ product.name }}</strong> 
              {{ product.description }} 
              <strong>+£{{ product.price }} 
                <template v-if="product.discount_message">({{ product.discount_message }})</template>
              </strong>
            </span>
          </label>
        </div>
    </div>
</template>

<script>
export default {
  name: "AddonProduct",
  props: ["product"],
  data() {
    return {
    };
  },
  methods: {
    onChange(e){
      this.$emit('toggleAddon', e.target.checked)
    }
  },
  mounted() {
    if (this.product.is_current_addon) {
      this.onChange({ target: { checked: true } });
    }
  }
};
</script>
<style scoped>
.container.auth-page .addon-product .checkbox:disabled + .box:after {
  color: #a9a9a9;
  cursor: not-allowed;
}
</style>